import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { contextualToolbarPluginKey } from './plugin-key';
var defaultEditState = {
  isCollapsed: true
};
export var contextualToolbarPlugin = function contextualToolbarPlugin() {
  return new SafePlugin({
    key: contextualToolbarPluginKey,
    state: {
      init: function init() {
        return defaultEditState;
      },
      apply: function apply(tr, pluginState) {
        var action = tr.getMeta(contextualToolbarPluginKey);
        if (action) {
          switch (action.type) {
            case 'expand-toolbar':
              return {
                isCollapsed: false
              };
            case 'collapse-toolbar':
              return {
                isCollapsed: true
              };
            default:
              return pluginState;
          }
        }
        return pluginState;
      }
    }
  });
};